import { render, staticRenderFns } from "./TargetNdcMonitoring.vue?vue&type=template&id=068562c8&scoped=true"
import script from "./TargetNdcMonitoring.vue?vue&type=script&lang=js"
export * from "./TargetNdcMonitoring.vue?vue&type=script&lang=js"
import style0 from "./TargetNdcMonitoring.vue?vue&type=style&index=0&id=068562c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068562c8",
  null
  
)

export default component.exports